import * as ng from 'angular';
import { ComponentRegistration } from '../../core';
import { Moment } from 'moment';
import { IActivitiesService } from './services/activities-service';
import { ISiteConfigService } from '../../core';
import { ISessionService } from '../../services';
import { Dto } from '../../data';
let template = require('./account-activity.html');

class AccountActivityComponent extends ComponentRegistration {

    constructor() {
        super('accountActivity', {
            controller: AccountActivityController,
            templateUrl: template,
            controllerAs: 'accountActivity',
            bindings: {
            }
        });
    }
}

interface IAccountActivityController {
    hasAccountActivities() : boolean;
    hasFrequentParkerAccountActivities() : boolean;
    hasAnyActivity() : boolean;
    onCriteriaChange(): void;
    onPrevNextClick(isNext): void;
    onDateRangeSelect(): void;
}

class AccountActivityController implements IAccountActivityController {
    private static $inject: Array<string> = ['Activities', 'SiteConfig', 'moment', 'Session'];

    private session: any = {};
    private allActivities: Array<any> = [];
    private activities: Array<any> = [];
    private fpActivities: Array<any> = [];
    private dateRanges: Array<any> = [];
    private amufEnabled: boolean = false;
    private dateRange: string;
    private frequentParkerActivityType: Array<any>;
    private criteria: Dto.IAccountActivityCriteria;
    
    constructor(private Activities: IActivitiesService,
        private SiteConfig: ISiteConfigService,
        private moment: Moment,
        private Session: ISessionService) {

        console.log('AccountActivityController loading');
    }

    public $onInit(): void {
        if (!this.Session.assureActiveUserSession()) return;
        this.SiteConfig.getConfigAsync()
            .then((config) => {
                this.amufEnabled = config.customerSettings.AMUF.enabled;
            });

        this.dateRanges = [
            'Week',
            'Month',
            'Quarter',
            'Year',
            'Custom'
        ];
        this.dateRange = this.dateRanges[1]; // default to Month

        this.frequentParkerActivityType = [
            { key: 0, value: null },
            { key: 1, value: 'Point Accrual' },
            { key: 2, value: 'Point Redemption' },
            { key: 3, value: 'Manual Point Adjustment' },
        ];

        this.criteria = {
            accountId: null,
            startDate: (this.moment as any)().startOf('month').toDate(),
            endDate: (this.moment as any)().endOf('month').toDate(),
            minAmount: null,
            maxAmount: null,
            mediaIdentifier: null,
            transactionType: null,
            pageSize: 0,
            pageNumber: 0
        } as Dto.IAccountActivityCriteria;
        
        this.Activities.loadAccountWithActivities(this, this.criteria, this.getFrequentParkerCriteria(this.criteria));

        console.log('AccountActivityController loaded');
    }

    public hasAccountActivities() : boolean {
        return this.activities && this.activities.length > 0;
    }

    public hasFrequentParkerAccountActivities() : boolean {
        return this.fpActivities && this.fpActivities.length > 0;
    }

    public hasAnyActivity() : boolean {
        // Note, if this.hasAccountActivities() or this.hasFrequentParkerAccountActivities() are true, his.allActivities will not be empty,
        // since the IActivitiesService service builds allActivities as union of activitird and frequent parker activities.
        // The oposite is also true (this.allActivities is not empty means that either hasAccountActivities() or hasFrequentParkerAccountActivities() should be true).
        // However, we don't want to make any assumptions on how IActivitiesService is implemented, so lets return true if any if these three are true.
        return this.hasAccountActivities() || this.hasFrequentParkerAccountActivities() ||
            this.allActivities && this.allActivities.length > 0;
    }

    public onCriteriaChange(): void {
        console.log('AccountActivityController: onCriteriaChange');
        this.Activities.loadAccountWithActivities(this, this.criteria, this.getFrequentParkerCriteria(this.criteria));
    }

    public onPrevNextClick(isNext): void {
        // default to Previous
        var dateRangeOffset = -1;
        if (isNext) {
            var dateRangeOffset = 1;
        }
        switch (this.dateRange) {
            case 'Month':
                this.criteria.startDate = (this.moment as any)(this.criteria.startDate).add(dateRangeOffset, 'M').toDate();
                this.criteria.endDate = (this.moment as any)(this.criteria.startDate).endOf('month').toDate();
                break;
            case 'Week':
                this.criteria.startDate = (this.moment as any)(this.criteria.startDate).add(dateRangeOffset, 'w').toDate();
                this.criteria.endDate = (this.moment as any)(this.criteria.startDate).endOf('week').toDate();
                break;
            case 'Quarter':
                this.criteria.startDate = (this.moment as any)(this.criteria.startDate).add(dateRangeOffset, 'Q').toDate();
                this.criteria.endDate = (this.moment as any)(this.criteria.startDate).endOf('quarter').toDate();
                break;
            case 'Year':
                this.criteria.startDate = (this.moment as any)(this.criteria.startDate).add(dateRangeOffset, 'y').toDate();
                this.criteria.endDate = (this.moment as any)(this.criteria.startDate).endOf('year').toDate();
                break;
            case 'Custom':
                // default custom dates to preselected previous values
                break;
            default:
                this.criteria.startDate = (this.moment as any)(this.criteria.startDate).add(dateRangeOffset, 'M').toDate();
                this.criteria.endDate = (this.moment as any)(this.criteria.startDate).endOf('month').toDate();
        };
        console.log('onPrevNextClick: startDate: ' + this.criteria.startDate);
        console.log('onPrevNextClick: endDate: ' + this.criteria.endDate);
        this.onCriteriaChange();
    }

    public onDateRangeSelect(): void {
        // set default start/end times for range selected
        switch (this.dateRange) {
            case 'Month':
                this.criteria.startDate = (this.moment as any)(this.criteria.startDate).startOf('month').toDate();
                this.criteria.endDate = (this.moment as any)(this.criteria.startDate).endOf('month').toDate();
                break;
            case 'Week':
                this.criteria.startDate = (this.moment as any)(this.criteria.startDate).startOf('week').toDate();
                this.criteria.endDate = (this.moment as any)(this.criteria.startDate).endOf('week').toDate();
                break;
            case 'Quarter':
                this.criteria.startDate = (this.moment as any)(this.criteria.startDate).startOf('quarter').toDate();
                this.criteria.endDate = (this.moment as any)(this.criteria.startDate).endOf('quarter').toDate();
                break;
            case 'Year':
                this.criteria.startDate = (this.moment as any)(this.criteria.startDate).startOf('year').toDate();
                this.criteria.endDate = (this.moment as any)(this.criteria.startDate).endOf('year').toDate();
                break;
            case 'Custom':
                // default custom dates to preselected previous values
                break;
            default:
                this.criteria.startDate = (this.moment as any)().startOf('month').toDate();
                this.criteria.endDate = (this.moment as any)().endOf('month').toDate();
        };
        this.onCriteriaChange();
    }

    public getFrequentParkerCriteria(crit: Dto.IAccountActivityCriteria): Dto.IFrequentParkerActivityCriteria {
        return {
            frequentParkerAccountId: null,
            startDate: crit.startDate,
            endDate: crit.endDate,
            activityType: null,
            pageSize: 0,
            pageNumber: 0
        } as Dto.IFrequentParkerActivityCriteria;
    }
}

let acctactComponent = new AccountActivityComponent();
export default acctactComponent;
export { acctactComponent as AccountActivityComponent, IAccountActivityController, AccountActivityController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/dashboard/account-activity.ts